/* Latif's Jewelry: shop pages always show full, even rows.
   Shopify sends fixed-size pages, and the site then hides pieces that are sold, have no photo
   or belong to another category, which leaves pages uneven. This pulls pieces from the following
   pages until the rows come out even, and swaps the page numbers for a "Load More Products" button
   so nothing is ever skipped. Without JavaScript the normal page numbers still work. */
(function () {
  var COLS = 4;   /* 4 across on computers, 2 on phones: a multiple of 4 is even on both */
  var STEP = 16;  /* pieces added per screen */
  var LABEL = 'Load More Products';

  if (!document.getElementById('lj-fill-style')) {
    var st = document.createElement('style');
    st.id = 'lj-fill-style';
    st.textContent =
      '.lj-more-wrap{display:flex;justify-content:center;padding:4rem 0 1rem}' +
      '.lj-more-wrap[hidden]{display:none}' +
      '.lj-more,.lj-more:hover,.lj-more:focus,.lj-more:disabled{min-width:24rem;letter-spacing:.2em;text-transform:uppercase;font-size:1.3rem;color:#fff !important;-webkit-text-fill-color:#fff;opacity:1}' +
      '.lj-fill-on .pagination-wrapper{display:none}';
    document.head.appendChild(st);
  }

  function shown(grid) {
    var n = 0;
    Array.prototype.forEach.call(grid.children, function (li) {
      if (li.classList.contains('grid__item') && getComputedStyle(li).display !== 'none') n++;
    });
    return n;
  }
  function nextLink(scope) {
    var a = scope.querySelector('.pagination-wrapper a.pagination__item--prev[href]');
    return a ? a.getAttribute('href') : null;
  }

  /* Remember how far a shopper got, so Back from a piece returns them to the same spot */
  var KEY = 'ljFill:' + location.pathname + location.search;
  var restored = false;
  function cameBack() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return nav && nav.type === 'back_forward';
    } catch (e) { return false; }
  }
  function readSaved() {
    if (!cameBack()) return null;
    try {
      var v = JSON.parse(sessionStorage.getItem(KEY));
      if (v && Date.now() - v.t < 30 * 60 * 1000) return v;
    } catch (e) {}
    return null;
  }
  function save(grid) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ count: shown(grid), y: window.scrollY, t: Date.now() }));
    } catch (e) {}
  }

  function setup() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.getAttribute('data-lj-fill') || !grid.classList.contains('product-grid')) return;
    grid.setAttribute('data-lj-fill', '1');
    var wrap = grid.closest('[id^="shopify-section-"]');
    if (!wrap) return;
    var sectionId = wrap.id.replace('shopify-section-', '');
    var next = nextLink(wrap);
    if (!next) return; /* only one page: nothing further to pull in */

    wrap.classList.add('lj-fill-on');
    var buffer = [];
    var holder = document.createElement('div');
    holder.className = 'lj-more-wrap';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button lj-more';
    btn.textContent = LABEL;
    btn.setAttribute('aria-label', LABEL);
    holder.appendChild(btn);
    grid.parentNode.insertBefore(holder, grid.nextSibling);

    function fetchNext() {
      var url = new URL(next, location.origin);
      next = null;
      url.searchParams.set('section_id', sectionId);
      return fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var g = tmp.querySelector('#product-grid');
          if (g) {
            Array.prototype.forEach.call(g.children, function (li) {
              if (li.classList.contains('grid__item')) buffer.push(li);
            });
          }
          next = nextLink(tmp);
        });
    }

    var busy = false;
    function fill(target, after) {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'Loading…';
      var guard = 0;
      function done() {
        busy = false;
        btn.disabled = false;
        btn.textContent = LABEL;
        holder.hidden = !(buffer.length || next);
        if (after) after();
      }
      function step() {
        if (++guard > 400) return done();
        var n = shown(grid);
        if (n >= target && n % COLS === 0) return done();
        if (buffer.length) {
          grid.appendChild(buffer.shift());
          return step();
        }
        if (next) return fetchNext().then(step, done);
        return done();
      }
      step();
    }

    btn.addEventListener('click', function () { fill(shown(grid) + STEP); });
    grid.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a[href*="/products/"]')) save(grid);
    });
    window.addEventListener('pagehide', function () { if (document.body.contains(grid)) save(grid); });

    var saved = restored ? null : readSaved();
    restored = true;
    if (saved && saved.count > STEP) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      fill(saved.count, function () { window.scrollTo(0, saved.y); });
    } else if (saved) {
      fill(STEP, function () { window.scrollTo(0, saved.y); });
    } else {
      fill(STEP);
    }
  }

  function init() {
    setup();
    /* Filters and sorting redraw the grid; set it up again when that happens */
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(setup, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
